// removed by extract-text-webpack-plugin
module.exports = {"dropzone":"_1V0Qtc2L3LC28Aa7M-2Se8","dropzoneActive":"_3-ZI7y-CBgRzLS3B6i05BQ"};


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/components/ImagesUploader.scss
// module id = 1504
// module chunks = 0